// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 869 ? "devtools" : chunkId) + "." + {"767":"d5c3c365","869":"f67a8fa5"}[chunkId] + ".chunk.js";
};